jQuery(function($) {
    // Vars //
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');

    // Functions
    backToTop();
    sliderSetup();
    featureProductSliderSetup();
    featureProductCategorySliderSetup();
    contentBlockSliderSetup();
    logoSliderBlockSetup();

    // Onclick Events
    $body
        .on('click', 'a.scroll-to-top', function (e) {
            e.preventDefault();
            var $trigger = $(this);

            $("html, body").animate({ scrollTop: 0 }, 1500);
            return false;
        })
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            // changed to apply class to all mobile triggers so I can have multiple on page
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $body.removeClass('no-scroll');
                $body.removeClass('position-fixed');
            }
            else {
                $mobileTriggers.addClass('active');
                $body.addClass('hamburger-menu-active');
                $body.addClass('no-scroll');
                $body.addClass('position-fixed');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        // Header search
        .on('click', '.nav-header-search-btn-js', function (e) {
            e.preventDefault();
            $('.nav-header-search').toggleClass('active');
        })
        // Close mobile menu when touching header search button
        .on('click', '.nav-header-search', function (e) {
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $body.removeClass('no-scroll');
                $body.removeClass('position-fixed');
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.accordion');
            var $accordionContent = jQuery($accordion).find('.accordion__content');
            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp();
            } else {
                $accordion.addClass('open');
                $accordionContent.slideDown();
            }
        })
        // mobile menu dropdown handling
        .on('click', '.menu-item-dropdown-toggle', function(e) {
            e.preventDefault();
            var $this = $(this);
            $navItem = $this.closest('.nav-list__item');
            $dropdownMenu = $navItem.children('.nav-list__dropdown');
            $navItem.toggleClass('submenu-active');

            $dropdownMenu.toggleClass('active');
            $dropdownMenu.slideToggle();

        })
        // when dropdown menus have headers on mobile (see explorate, veto for examples)
        .on('click', '.dropdown-header-back', function(e) {
            e.preventDefault();
            var $this = $(this);
            $this.closest('.nav-list__item').removeClass('submenu-active');
            $this.closest('.nav-list__dropdown').removeClass('active').slideToggle();

        })
        // woocommerce quantity plus / minus buttons
        .on('click', '.quantity-wrapper .plus, .quantity-wrapper .minus', function(e) {
            e.preventDefault();
            // Get current quantity values
            var qty = $( this ).closest( 'form.cart' ).find( '.qty' );
            var val = parseFloat(qty.val());
            var max = parseFloat(qty.attr( 'max' ));
            var min = parseFloat(qty.attr( 'min' ));
            var step = parseFloat(qty.attr( 'step' ));
 
            // Change the value if plus or minus
            if ( $( this ).is( '.plus' ) ) {
                if ( max && ( max <= val ) ) {
                  qty.val( max );
                } else {
                    qty.val( val + step );
                }
            } else {
                if ( min && ( min >= val ) ) {
                    qty.val( min );
                } else if ( val > 1 ) {
                    qty.val( val - step );
                }
            }
        })
        // Product Quick View open
        .on('click', '.product-card .quick-view-btn', function(e) {
            var product_id = $(this).data('product_id');
            var product_url = $(this).data('product_url');

            $.ajax({
                type: 'get',
                url: wc_add_to_cart_params.ajax_url,
                data: {
                    action: 'sc_get_quick_view_data',
                    product_id: product_id
                },
                beforeSend: function (response) {
                    $('.product-quick-view').addClass('loading');
                    $('.product-quick-view .product-quick-view__image').empty();
                    $('.product-quick-view .product-quick-view__summary').empty();
                    $('.product-quick-view').fadeIn();
                },
                complete: function (response) {
                    $('.product-quick-view').removeClass('loading') ;
                },
                success: function (response) {
                    if (response.error == true) {
                        alert("Error loading quick view");
                    } else {
                        var more_details_btn = '<a href="'+product_url+'" class="more-details-btn btn btn-ghost">View More Details</a>';

                        $('.product-quick-view .product-quick-view__image').html(response.image);
                        $('.product-quick-view .product-quick-view__summary').html(response.summary + more_details_btn);

                        loadVariationScript();
                    }
                },
            });
            
        })
        // Product Quick View close
        .on('click', '.product-quick-view .close, .product-quick-view .product-quick-view--background', function(e) {
            $('.product-quick-view').fadeOut();
        })
        // Added to cart slide out close
        .on('click', '.added-to-cart-slide-out .close, .added-to-cart-slide-out .added-to-cart-slide-out--background, .added-to-cart-slide-out .continue-shopping-js', function(e) {
            $('.added-to-cart-slide-out').fadeOut();
        })
    ;

    // Hide header search dropdown on click outside element
    $(document).on("click", function(event){

        // click outside .nav-header-search element
        if ( $('.nav-header-search').hasClass('active') && !$(event.target).closest('.nav-header-search').length ) {
            $('.nav-header-search').removeClass('active');
        }
    });

    function loadVariationScript() {
        $.getScript( "/wp-content/plugins/woocommerce/assets/js/frontend/add-to-cart-variation.min.js" )
        .done(function( script, textStatus ) {
            $('.variations_form').each(function () {
                $(this).wc_variation_form();
            });
        })
        .fail(function( jqxhr, settings, exception ) {
            $( "div.log" ).text( "Triggered ajaxError handler." );
        });

        
    }

    // Resize Functions //
    var resizeThreshold;
    $(window).on('resize', function () {
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                backToTop();
                sliderSetup();
                featureProductSliderSetup();
                featureProductCategorySliderSetup();
                contentBlockSliderSetup();
                logoSliderBlockSetup();
            }, 100);
        }, 200);
    });

    // Single product page thumbnail slider
    if ($('body').hasClass('single-product')) {
        $('.product-gallery-nav').flexslider({
            animation: 'slide',
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            direction: 'vertical',
            itemWidth: 120,
            itemMargin: 0,
            selector: '.slides > .woocommerce-product-gallery__image',
            asNavFor: '.woocommerce-product-gallery'
        });
    }

    /**
     * AJAX Add to Cart
     */
    $(document.body).on( 'click', 'form.cart .single_add_to_cart_button:not(".disabled")', function(e) { 	
        e.preventDefault();

        var add_to_cart_form = $( this ).closest( 'form.cart' );

        var product_id = '';
        var var_id = '';
        var is_variation = add_to_cart_form.hasClass( 'variations_form' );
        var attributes = {};
        var quantity = add_to_cart_form.find( 'input[type=number]' ).val();

        // If Variation add to cart
        if (is_variation) {
            product_id = add_to_cart_form.find( 'input[name=product_id]' ).val();
            var_id = add_to_cart_form.find( 'input[name=variation_id]' ).val();

            var empty_attribute = false;
            // get variation attributes 
            add_to_cart_form.find('.variations select').each(function( index, elem ) {
                var attribute_name = $(this).data('attribute_name');
                var attribute_value = $(this).val();

                if (!attribute_value || attribute_value.length === 0 ) {
                    empty_attribute = true;
                }

                attributes[attribute_name] = attribute_value;
            });

            // do not continue if we have empty attributes
            if (empty_attribute) {
                return;
            }

        } else {
            // Get Simple Product ID from button value
            product_id = $(this).attr('value');
        }

        // prepare data for AJAX
        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            quantity: quantity,
            product_sku: '',
            variation_id: var_id,
            variation: JSON.stringify(attributes)
        };

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $(add_to_cart_form).find('.button').addClass('loading');
            },
            complete: function (response) {
                $(add_to_cart_form).find('.button').removeClass('loading') ;
            },
            success: function (response) {
                if (response.error == true) {
                    alert("Error adding item to cart");
                } else {
                    $(add_to_cart_form).find('.button').addClass('AddedtoCart');
                    $(add_to_cart_form).find('.hidden_view_cart').addClass('active');
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                }
            },
        });
    }); // end AJAX Add to Cart

    // Trigger Added to cart slide out on WC "added_to_cart" event
    $(document.body).on( 'added_to_cart', function() {
        var relatedProducts = $('#main .related.products .product-grid').html();
        $('.product-quick-view').fadeOut();
        $('.added-to-cart-slide-out').fadeIn();
    });

});